import { TelSysTypes } from '../TelSysConfiguration/Constants/Constants'

export enum CMEModalID {
    DETAILS,
    DOMAIN,
    PROVISIONING,
    LICENSE_MANAGEMENT,
    CAPABILITIES,
    BRANDING,
    ESTATE,
    ADVANCED
}

export const PROVISIONING_ITEM_TYPE_EXTENSION: string = 'EXTENSION'
export const PROVISIONING_ITEM_TYPE_HOSPITALITY: string = 'HOSPITALITY'
export const PROVISIONING_ITEM_TYPE_ACD_AGENT: string = 'ACD_AGENT'
export const PROVISIONING_ITEM_TYPE_ESSENTIALS: string = 'ESSENTIALS'
export const PROVISIONING_ITEM_TYPE_PROFESSIONAL: string = 'PROFESSIONAL'
export const PROVISIONING_ITEM_TYPE_ENTERPRISE: string = 'ENTERPRISE'
export const PROVISIONING_ITEM_TYPE_CALL_CENTRE_AGENT: string = 'CALL_CENTRE_AGENT'
export const PROVISIONING_ITEM_TYPE_CALL_CENTRE_SUPERVISOR: string = 'CALL_CENTRE_SUPERVISOR'
export const PROVISIONING_ITEM_TYPE_1000: string = 'ONE_THOUSAND'
export const PROVISIONING_ITEM_TYPE_2000: string = 'TWO_THOUSAND'

export const ROOT_CME_ID: string = 'd6d6c5a5f0f90d60:-15617a00:169f533f6d5:5613'

export enum CapabilityBitFlags {
    LEGACY_TELEPHONY = 0x0100,
    CXA_BROADWORKS = 0x0200,
    CXA_WEBEX = 0x0400,
    CXA_TEAMS = 0x0800,
    CXA_LEGACY = 0x0001,
    ENTERPRISE = 0x0002,
    CXI_BROADWORKS = 0x1000,
    CXI_WEBEX = 0x2000,
    CXI_TEAMS = 0x4000
}

export const telSysCapabilityBitFlags: Record<TelSysTypes, CapabilityBitFlags> = {
    [TelSysTypes.WEBEX_CALLING]: CapabilityBitFlags.CXA_WEBEX,
    [TelSysTypes.BROADSOFT_BROADWORKS]: CapabilityBitFlags.CXI_BROADWORKS,
    [TelSysTypes.MS_TEAMS]: CapabilityBitFlags.CXI_TEAMS
} as Record<TelSysTypes, CapabilityBitFlags>

export const ANY_NUMBER_OF_TELSYS_AVAILABLE: string = '[ANY]'
export const ANY_NUMBER_OF_TELSYS_AVAILABLE_VALUE: number = -1
